<template>
	<div class="bootbox modal fade in show" tabindex="-1" role="dialog" style="display: block;">
		<div class="modal-dialog">
			<div class="modal-content">
				<div class="modal-body">
					<button type="button" class="bootbox-close-button close" data-dismiss="modal" aria-hidden="true" style="margin-top: -10px;" @click="closePopup">×</button>
					<div class="bootbox-body">
						<section class="panel">
							<div class="panel-body">
								<div class="row form-group">
									<div class="col-md-12">
										<div>1.用餐方式<span style="color:#FF0000;">*</span></div>
										<div class="s_ap_m">
											<label class="s_radio"><input type="radio" v-validate="'required|included:M,V'" name="foodType" value="M" v-model="popupParam.foodType" :disabled="isShow"> 葷食</label>
											<label class="s_radio"><input type="radio" name="foodType" value="V" v-model="popupParam.foodType" :disabled="isShow"> 素食</label>
										</div>
										<span class="text-danger" v-show="errors.has('foodType')">{{ errors.first('foodType') }}</span>
									</div>
								</div>
								<div class="row form-group">
									<div class="col-md-12">
										<div>2.就寢時間<span style="color:#FF0000;">*</span></div>
										<div class="s_ap_m">
											<label class="s_radio"><input type="radio" v-validate="'required|included:1,2,3,4,5,6,7'" name="stepTime" value="1" v-model="popupParam.stepTime"> 19點~20點</label>
											<label class="s_radio"><input type="radio" name="stepTime" value="2" v-model="popupParam.stepTime" :disabled="isShow"> 20點~21點</label>
											<label class="s_radio"><input type="radio" name="stepTime" value="3" v-model="popupParam.stepTime" :disabled="isShow"> 21點~22點</label>
											<label class="s_radio"><input type="radio" name="stepTime" value="4" v-model="popupParam.stepTime" :disabled="isShow"> 22點~23點</label>
											<label class="s_radio"><input type="radio" name="stepTime" value="5" v-model="popupParam.stepTime" :disabled="isShow"> 23點~0點</label>
											<label class="s_radio"><input type="radio" name="stepTime" value="6" v-model="popupParam.stepTime" :disabled="isShow"> 0點~1點</label>
											<label class="s_radio"><input type="radio" name="stepTime" value="7" v-model="popupParam.stepTime" :disabled="isShow"> 1點~2點</label>
										</div>
										<span class="text-danger" v-show="errors.has('stepTime')">{{ errors.first('stepTime') }}</span>
									</div>
								</div>
								<div class="row form-group">
									<div class="col-md-12">
										<div>3.平均上網時間<span style="color:#FF0000;">*</span></div>
										<div class="s_ap_m">
											<label class="s_radio"><input type="radio" v-validate="'required|included:1,2,3,4,5,6'" name="netUseTime" value="1" v-model="popupParam.netUseTime" :disabled="isShow">
												1小時/天</label>
											<label class="s_radio"><input type="radio" name="netUseTime" value="2" v-model="popupParam.netUseTime" :disabled="isShow">
												2小時/天</label>
											<label class="s_radio"><input type="radio" name="netUseTime" value="3" v-model="popupParam.netUseTime" :disabled="isShow">
												3小時/天</label>
											<label class="s_radio"><input type="radio" name="netUseTime" value="4" v-model="popupParam.netUseTime" :disabled="isShow">
												4小時/天</label>
											<label class="s_radio"><input type="radio" name="netUseTime" value="5" v-model="popupParam.netUseTime" :disabled="isShow">
												5小時/天</label>
											<label class="s_radio"><input type="radio" name="netUseTime" value="6" v-model="popupParam.netUseTime" :disabled="isShow">
												5小時以上/天</label>
										</div>
										<span class="text-danger" v-show="errors.has('netUseTime')">{{ errors.first('netUseTime') }}</span>
									</div>
								</div>
								<div class="row form-group">
									<div class="col-md-12">
										<div>4.是否抽菸<span style="color:#FF0000;">*</span></div>
										<div class="s_ap_m">
											<label class="s_radio"><input type="radio" v-validate="'required|included:Y,N'" name="isSmoke" value="Y" v-model="popupParam.isSmoke" :disabled="isShow"> 是</label>
											<label class="s_radio"><input type="radio" name="isSmoke" value="N" v-model="popupParam.isSmoke" :disabled="isShow"> 否</label>
										</div>
										<span class="text-danger" v-show="errors.has('isSmoke')">{{ errors.first('isSmoke') }}</span>
									</div>
								</div>
								<div class="row form-group">
									<div class="col-md-12">
										<div>5.平均幾天整理環境<span style="color:#FF0000;">*</span></div>
										<div class="s_ap_m">
											<label class="s_radio"><input type="radio" v-validate="'required|included:1,2,3,4,5'" name="cleanDay" value="1" v-model="popupParam.cleanDay" :disabled="isShow"> 1天</label>
											<label class="s_radio"><input type="radio" name="cleanDay" value="2" v-model="popupParam.cleanDay" :disabled="isShow"> 2天</label>
											<label class="s_radio"><input type="radio" name="cleanDay" value="3" v-model="popupParam.cleanDay" :disabled="isShow"> 3天</label>
											<label class="s_radio"><input type="radio" name="cleanDay" value="4" v-model="popupParam.cleanDay" :disabled="isShow"> 4天</label>
											<label class="s_radio"><input type="radio" name="cleanDay" value="5" v-model="popupParam.cleanDay" :disabled="isShow"> 5天</label>
										</div>
										<span class="text-danger" v-show="errors.has('cleanDay')">{{ errors.first('cleanDay') }}</span>
									</div>
								</div>
								<div class="row form-group">
									<div class="col-md-12">
										<div>6.其他需求</div>
										<div class="s_ap_m">
											<textarea style="width:100%" name="otherRequest" v-model="popupParam.otherRequest" rows="5" v-validate="'max:200'" maxlength="200" :disabled="isShow"></textarea>
										</div>
										<span class="text-danger" v-show="errors.has('otherRequest')">{{ errors.first('otherRequest') }}</span>
									</div>
								</div>
								<div class="col-md-12 " v-if="isShow">
									<div class="s_tenc">
										<a @click="closePopup" class="btn-upload btn s_btn_g mr-md">返回</a>
									</div>
								</div>
								<div class="col-md-12 " v-else>
									<div class="s_tenc">
										<a @click="handleRest" class="btn-upload btn s_btn_g mr-md">重填</a>
										<a @click="handleSave" class="btn-upload btn btn-danger mr-md">送出</a>
									</div>
								</div>
							</div>
						</section>
					</div>
				</div>
			</div>
		</div>
	</div>

</template>

<script>
export default {
	delimiters: ['${', '}'],
	props: ['foodType', 'stepTime', 'isSmoke','cleanDay','netUseTime','otherRequest', 'isShow'],
	data() {
		return {
			popupParam:{
				foodType: this.foodType,
				stepTime: this.stepTime,
				isSmoke: this.isSmoke,
				cleanDay: this.cleanDay,
				otherRequest: this.otherRequest,
				netUseTime: this.netUseTime
			}
		}
	},
	created() {
		this.popupParam = {
			foodType: this.foodType,
			stepTime: this.stepTime,
			isSmoke: this.isSmoke,
			cleanDay: this.cleanDay,
			otherRequest: this.otherRequest,
			netUseTime: this.netUseTime
		}
	},
	methods: {
		handleSave() {
			let _this = this;
			this.$validator.validateAll().then((result) => {
				if (result) {
					_this.$parent.saveContorl(this.popupParam);
				} else {
					bootbox.alert('請確認必填欄位是否有填寫')
				}
			});
		},
		handleRest() {
			this.popupParam = {
				foodType: this.foodType,
				stepTime: this.stepTime,
				isSmoke: this.isSmoke,
				cleanDay: this.cleanDay,
				otherRequest: this.otherRequest,
				netUseTime: this.netUseTime
			}
		},
		closePopup() {
			this.$parent.showPopupControl(false);
		}
	},
}
</script>

<style scoped>
@media only screen and (max-device-height : 667px){
	.bootbox-body{
		max-height:480px;
		overflow-y:auto;
	}
}
@media only screen and (max-device-height : 736px) {
	.bootbox-body{
		max-height:600px;
		overflow-y:auto;
	}
}
</style>

